/**
 * 네이버 지도 로더 — 명세서 §5.20 P6, §14.1-19
 *
 * VITE_NAVER_MAP_CLIENT_ID가 빌드에 없으면 지도를 로드하지 않고 null을 준다.
 * 화면은 null이면 텍스트 현황으로 폴백한다 — 키가 없어도 기능은 동작해야 한다.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */

let loader: Promise<any | null> | null = null;

export function loadNaverMaps(): Promise<any | null> {
  const clientId = import.meta.env.VITE_NAVER_MAP_CLIENT_ID as string | undefined;
  if (!clientId) return Promise.resolve(null);

  const existing = (window as any).naver;
  if (existing?.maps) return Promise.resolve(existing);

  if (!loader) {
    loader = new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = `https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=${encodeURIComponent(clientId)}`;
      script.async = true;
      script.onload = () => resolve((window as any).naver ?? null);
      // 로드 실패(키 오류·네트워크)도 폴백 화면으로 — 오류를 화면까지 올리지 않는다
      script.onerror = () => resolve(null);
      document.head.appendChild(script);
    });
  }
  return loader;
}
